import {Box, Grid, Switch, TextField, Typography} from "@mui/material";
import * as React from "react";
import {translate} from "../../translate/translate";
import {Field, Form, Formik} from "formik";
import {Add, Delete} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import {useEffect} from "react";
import {Value} from "../table/value-row-column.component";

const AddItemListComponent = (props: any) => {
    const {
        field,
        list,
        title,
        changeList,
        hasSwitch = false,
        switchLabel = "",
        switchField = "",
    } = props;

    const [name, setName] = React.useState("");
    const [listControl, setListControl] = React.useState(list);

    useEffect(() => {
        changeList(listControl);
    }, []);

    const addToList = (value: string) => {
        const newItem = { [field]: value.trim(), ...(hasSwitch ? { [switchField]: true } : {}) };
        const updatedList = [newItem, ...listControl];
        setListControl(updatedList);
        changeList(updatedList);
    };

    const removeFromList = (index: number) => {
        const updatedList = listControl.filter((_: any, i: number) => i !== index);
        setListControl(updatedList);
        changeList(updatedList);
    };

    const changeValueFromList = (value: any, index: number, isSwitch = false) => {
        const updatedList = [...listControl];
        const f = isSwitch ? switchField : field;
        updatedList[index][f] = value;
        setListControl(updatedList);
        changeList(updatedList);
    };

    return (
        <Grid p={0} mt={3} gap={2}>
            {title && (
                <Typography variant="h6" mb={1}>
                    {title}
                </Typography>
            )}
            {switchLabel && hasSwitch && (
                <Box mb={1} display="flex" justifyContent="flex-end">
                    <Typography variant="subtitle2" fontWeight="bold" width="80px" textAlign="center">
                        {switchLabel}
                    </Typography>
                </Box>
            )}
            <Formik
                enableReinitialize={true}
                validateOnMount={true}
                initialValues={{ [field]: "" }}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        addToList(name);
                        setName("");
                        setSubmitting(false);
                    }, 500);
                }}
            >
                {() => (
                    <Form autoComplete="off">
                        <Grid alignItems="center" container spacing={2} direction={"row"} mb={2}>
                            <Grid size={10}>
                                <Field
                                    as={TextField}
                                    name={field}
                                    label={translate.t(field)}
                                    fullWidth
                                    required
                                    variant={"outlined"}
                                    autoFocus={false}
                                    value={name}
                                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                                        if (event.target.value && event.target.value.toString().length > 255) {
                                            return;
                                        }
                                        setName(event.target.value as string);
                                    }}
                                />
                            </Grid>
                            <Grid size={hasSwitch ? 1 : 2}>
                                <IconButton
                                    id="btn_menu"
                                    color="inherit"
                                    aria-label="add"
                                    type="submit"
                                    disabled={!name.trim()}
                                    edge="start"
                                >
                                    <Add />
                                </IconButton>
                            </Grid>

                            {hasSwitch && (
                                <Grid size={1}>
                                    <Switch
                                        color="secondary"
                                        checked={true}
                                        disabled
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {listControl.length > 0 && (
                            <>
                                {listControl.map((item: any, index: number) => (
                                    <Grid
                                        key={index}
                                        alignItems="center"
                                        container
                                        spacing={2}
                                        mt={2}
                                        direction={"row"}
                                    >
                                        <Grid size={10}>
                                            <Field
                                                as={TextField}
                                                name={`name-${index}`}
                                                label={translate.t(field)}
                                                fullWidth
                                                required
                                                variant={"outlined"}
                                                autoFocus={false}
                                                value={item[field]}
                                                onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                                                    if (event.target.value && event.target.value.toString().length > 255) {
                                                        return;
                                                    }
                                                    changeValueFromList(event.target.value as string, index)
                                                }}
                                                error={item[field].trim() === ""}
                                            />
                                        </Grid>
                                        <Grid size={hasSwitch ? 1 : 2}>
                                            <IconButton
                                                id="btn_menu"
                                                color="inherit"
                                                aria-label="remove"
                                                onClick={() => removeFromList(index)}
                                                edge="start"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </Grid>
                                        {hasSwitch && (
                                            <Grid size={1}>
                                                <Switch
                                                    color="secondary"
                                                    checked={item[switchField] ?? true}
                                                    onChange={() => {
                                                        changeValueFromList(!item[switchField], index, true)
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                ))}
                            </>
                        )}
                    </Form>
                )}
            </Formik>
        </Grid>
    );
};

export default AddItemListComponent;

